export enum ROUTE_ALIAS {
  ACCOUNT = 'account',
  CLAIM = 'claim',
  NFTS = 'nfts',
  COLLECTIONS = 'collections',
  ARTISTS = 'artists',
  CHECKOUT = 'checkout'
}

export const ROUTE_RESERVED_ALIASES = Object.values(ROUTE_ALIAS);

export const COLLECTION_VIEW_URL_PATTERN = /\/collections\/([^/]+)$/;
export const ARTIST_VIEW_URL_PATTERN = /\/artists\/([^/]+)$/;
export const NFT_VIEW_URL_PATTERN = /^\/nfts\/([^/]+)$/;
export const NFT_CHECKOUT_PATTERN = /^\/nft-checkout\/([^/]+)$/;
export const CLAIM_NFT_URL_PATTERN = /\/claim\/[^/]+$/;
export const UNSUBSCRIBE_URL_PATTERN = /\/account\/unsubscribe(\?.*)?$/;
export const NEWS_LETTER_UNSUBSCRIBE_URL_PATTERN =
  /\/account\/unsubscribe-marketing(\?.*)?$/;
